import { Box } from "@chakra-ui/react";
import { ChakraProps } from "@chakra-ui/system";
import { ROW_EXPANDER_ICON_SIZE } from "shared/components/table/TableRowExpandButton";
import { SmallArrowDownIcon } from "shared/icons/SmallArrowDownIcon";

export interface ContentExpandButtonProps extends ChakraProps {
  isExpanded: boolean;
  isDisabled?: boolean;
  reduceMotion?: boolean;
}

export const ContentExpandButton: React.FC<ContentExpandButtonProps> = ({
  isExpanded,
  isDisabled,
  reduceMotion,
  sx,
  ...props
}) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    width={`${ROW_EXPANDER_ICON_SIZE}px`}
    height={`${ROW_EXPANDER_ICON_SIZE}px`}
    borderRadius="2px"
    color="gray.500"
    sx={{
      "button:hover &": {
        bg: "gray.100",
      },
      "button:active &": {
        bg: "gray.200",
      },
      ...sx,
    }}
    {...props}
  >
    <SmallArrowDownIcon
      rotate={isExpanded ? 0 : -90}
      opacity={isDisabled ? 0.4 : 1}
      transform={isExpanded ? undefined : "rotate(-90deg)"}
      transition={reduceMotion ? undefined : "transform 0.2s"}
      transformOrigin="center"
    />
  </Box>
);
